import script from "./NavigationGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationGuide.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationGuide.vue?vue&type=style&index=0&id=05bd80e9&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05bd80e9"]])

export default __exports__